<template>

	<div class="content clearfix">
		<div class="main clearfix">
			<div class="c-left fl">
				<!--轮播图 start-->
				<el-carousel indicator-position="outside">
					<el-carousel-item v-for="(item,index) in imgList" :key="index">
						<a :href="item.url"><img :src="item.img" width="680" height="400"></a>
					</el-carousel-item>
				</el-carousel>
				<!--轮播图 end-->

				<div class="slideTxtBox pr">
					<span class="more">
				    	<a href="#/NewsList/0">更多>></a>
				    </span>
					<el-tabs v-model="activeName" @tab-click="handleClick">

						<!--<el-tab-pane label="最新资讯" name="first" class="bd">

							<ul>
								<li v-for="(item,index) in zuixinzixun"><span class="date">{{item.create_time | formatDate}}</span>
									<a :href="'#/NewSInfo/' + item.id " target="_blank">{{item.title}}</a>
								</li>
							</ul>
						</el-tab-pane>-->
						<el-tab-pane label="国际交流" name="1" class="bd">
							<ul>
								<li v-for="(item,index) in guojijiaoliu"><span class="date">{{item.create_time | formatDate}}</span>
									<a :href="'#/NewSInfo/' + item.id " target="_blank">{{item.title}}</a>
								</li>
							</ul>
						</el-tab-pane>
						<el-tab-pane label="行业动态" name="2" class="bd">
							<ul>
								<li v-for="(item,index) in hangyedongtai"><span class="date">{{item.create_time | formatDate}}</span>
									<a :href="'#/NewSInfo/' + item.id " target="_blank">{{item.title}}</a>
								</li>
							</ul>
						</el-tab-pane>
						<el-tab-pane label="协会专栏" name="3" class="bd">
							<ul>
								<li v-for="(item,index) in xiehuizhuanlan"><span class="date">{{item.create_time | formatDate}}</span>
									<a :href="'#/NewSInfo/' + item.id " target="_blank">{{item.title}}</a>
								</li>
							</ul>
						</el-tab-pane>
						<el-tab-pane label="关于培训" name="4" class="bd">
							<ul>
								<li v-for="(item,index) in guanyupeixun"><span class="date">{{item.create_time | formatDate}}</span>
									<a :href="'#/NewSInfo/' + item.id " target="_blank">{{item.title}}</a>
								</li>
							</ul>
						</el-tab-pane>
						<el-tab-pane label="党建工作" name="5" class="bd">
							<ul>
								<li v-for="(item,index) in dangjiangongzuo"><span class="date">{{item.create_time | formatDate}}</span>
									<a :href="'#/NewSInfo/' + item.id " target="_blank">{{item.title}}</a>
								</li>
							</ul>
						</el-tab-pane>
						<el-tab-pane label="信息公示" name="6" class="bd">
							<ul>
								<li v-for="(item,index) in xinxigongshi"><span class="date">{{item.create_time | formatDate}}</span>
									<a :href="'#/NewSInfo/' + item.id " target="_blank">{{item.title}}</a>
								</li>
							</ul>
						</el-tab-pane>
					</el-tabs>
				</div>
				<!--协会信息-->
				<div class="association-msg">
					<div class="hd">
						<h3>协会信息</h3>
					</div>
					<div class="bd">
						<div class="article-left fl">
							<div class="img mb10"><a href="http://www.bbsca-ifm.cn/#/NewSInfo/72"><img src="http://www.jiemancang.com/image/2018-11-14/1542187269870.jpg" width="210" height="122" /></a></div>
							<div class="title"><a href="http://www.bbsca-ifm.cn/#/NewSInfo/72">北京建筑设施服务企业协会会长张红应邀参加“MICO美高杯”第二届浙江省清洗保洁行业职业技能竞赛并担任保洁组裁判员</a></div>
						</div>
						<div class="article-left fl">
							<div class="img mb10"><a href="http://www.bbsca-ifm.cn/#/NewSInfo/78"><img src="http://www.jiemancang.com/image/2018-11-15/1542246048089.jpg" width="210" height="122" /></a></div>
							<div class="title"><a href="http://www.bbsca-ifm.cn/#/NewSInfo/78">北京建筑设施服务企业协会会长张红走访福建省清洗保洁行业协会交流洽谈</a></div>
						</div>
						<div class="article-left fl">
							<div class="img mb10"><a href="http://www.bbsca-ifm.cn/#/NewSInfo/73"><img src="http://www.jiemancang.com/image/2018-11-14/1542188609416.jpg" width="210" height="122" /></a></div>
							<div class="title"><a href="http://www.bbsca-ifm.cn/#/NewSInfo/73">《中国物业管理》总编赵富林一行莅临北京建筑设施服务企业协会洽谈</a></div>
						</div>
					</div>
				</div>

			</div>
			<div class="c-right fr">
				<div class="association-info mb20">
					<div class="item">
						<a href="#/Speech" class="a01">会长致辞</a>
						<a href="#/Introduction" class="a02">协会简介</a>
						<a href="#/Constitution" class="a03">章程公示</a>

					</div>
					<!--	<div class="img mb20">
						<a :href="'#/NewSInfo/' + newInfo.id"><img :src="newInfo.img" width="460" height="240" /></a>
					</div>
					<div class="txt">
						{{newInfo.title}}
					</div>-->
					<div class="img mb20">
						<a href="#/Introduction"><img src="../assets/images/xh-right01.jpg" width="460" height="240" /></a>
					</div>
					<div class="txt">
						<a href="#/Introduction">北京建筑设施服务企业协会是经北京市社会团体登记管理机关核准登记的非营利性社会团体。协会秉承“感恩、进步、共享”的办会发展理念，搭建跨界交流，共创商机的发展平台。</a>
					</div>
				</div>
				<div class="authenticate-box mb20">
					<div class="hd">
						清洁服务师认证通道
					</div>
					<div class="bd">
						<div class="img fl">
							<img src="../assets/images/xh-renzheng.jpg" width="340" height="170" />
						</div>
						<div class="txt fr">
							<a href="#/MaintainPage" class="a01">考试平台</a>
							<a href="#/MaintainPage" class="a02">认证查询</a>
							<a href="#/MaintainPage" class="a03">培训专区</a>
						</div>
					</div>
				</div>
				<div class="association-service">
					<div class="hd">
						<h3>协会服务</h3>
					</div>
					<div class="bd">
						<ul>
							<li><input class="a-input" type="text" placeholder="请输入您的企业名称" v-model="COMPANY" /></li>
							<li><input class="a-input" type="text" placeholder="请输入您的称呼" v-model="NAME" /></li>
							<li><input class="a-input" type="text" placeholder="请输入您的联系方式" v-model="PHONE" /></li>
							<li>
								<a href="javascript:;" class="btn" @click="doRegist()">申请加入</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

		</div>
		<div class="w1200 clearfix">
			<div class="links">
				<div class="hd">
					<h3>友情链接</h3>
				</div>
				<div class="bd">
					<a href="http://www.jiemancang.com/" target="_blank">北京洁满仓科技有限公司</a>
					<a href="http://www.xinyujia.com.cn" target="_blank">北京信宇佳清洁服务有限责任公司</a>
					<a href="http://www.bjxalj.com/" target="_blank">北京市新奥靓洁保洁有限公司</a>
					<a href="http://www.shcg.com.cn/" target="_blank">北京三和晨光物业管理有限公司</a>
					<a href="http://www.bjqxbaoan.com/" target="_blank">北京千翔保安服务有限公司</a>
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import Vue from 'vue';
	import Element from 'element-ui';
	import 'element-ui/lib/theme-chalk/index.css';
	import { formatDate } from '../assets/js/date.js';
	Vue.use(Element, {
		size: 'small',
		zIndex: 3000
	});

	export default {
		filters: { //格式化日期
			formatDate(time) {
				var date = new Date(time);
				return formatDate(date, 'yyyy-MM-dd');
			}
		},
		name: 'HelloWorld',
		data() {
			return {
				path: domain.apiUrl,
				activeName: '1',
				imgList: [],
				zuixinzixun: [],
				hangyedongtai: [],
				guojijiaoliu: [],
				xiehuizhiyou: [],
				xinxigongshi: [],
				guanyupeixun: [],
				xiehuizhuanlan: [],
				dangjiangongzuo: [],
				newInfo: {},
				indexs: 0,
				COMPANY: "",
				NAME: "",
				PHONE: "",
				/*newsid:'60'//首页右侧图文id*/
			}
		},
		mounted: function() {
			this.getImglist();
			this.getZuixinzixun();
			this.getHangyedongtai();
			this.getGuojijiaoliu();
			this.getXiehuizhiyou();
			this.getXinxigongshi();
			this.getGuanyupeixun();
			this.getXiehuizhuanlan();
			this.getDangjiangongzuo();
		},
		methods: {

			handleClick(tab, event) {
			},
			//首页轮播图
			getImglist: function() {
				this.$http.get(this.path + 'index/getBanners').then((response) => {
					if(response.status === 200) {
						var data = response.body;
						this.imgList = data.banners;
					}

				}, (response) => {
					this.$message.error("error")
				});
			},
			//最新资讯
			getZuixinzixun: function() {
				this.$http.get(this.path + 'index/getNewsList?groupId=0').then((response) => {
					if(response.status === 200) {
						var data = response.body;
						this.zuixinzixun = data.newsList;
					} else {
						this.$message.error("error")
					}

				}, (response) => {

				});
			},
			//行业动态
			getHangyedongtai: function() {
				this.$http.get(this.path + 'index/getNewsList?groupId=1').then((response) => {
					if(response.status === 200) {
						var data = response.body;
						this.hangyedongtai = data.newsList;
					} else {
						this.$message.error("error")
					}

				}, (response) => {

				});
			},
			//国际交流
			getGuojijiaoliu: function() {
				this.$http.get(this.path + 'index/getNewsList?groupId=2').then((response) => {
					if(response.status === 200) {
						var data = response.body;
						this.guojijiaoliu = data.newsList;
					} else {
						this.$message.error("error")
					}

				}, (response) => {

				});
			},
			//协会之友
			getXiehuizhiyou: function() {
				this.$http.get(this.path + 'index/getNewsList?groupId=3').then((response) => {
					if(response.status === 200) {
						var data = response.body;
						this.xiehuizhiyou = data.newsList;
					} else {
						this.$message.error("error")
					}

				}, (response) => {

				});
			},
			//信息公示
			getXinxigongshi: function() {
				this.$http.get(this.path + 'index/getNewsList?groupId=5').then((response) => {
					if(response.status === 200) {
						var data = response.body;
						this.xinxigongshi = data.newsList;
					} else {
						this.$message.error("error")
					}

				}, (response) => {

				});
			},
			//关于培训
			getGuanyupeixun: function() {
				this.$http.get(this.path + 'index/getNewsList?groupId=9').then((response) => {
					if(response.status === 200) {
						var data = response.body;
						this.guanyupeixun = data.newsList;
					} else {
						this.$message.error("error")
					}

				}, (response) => {

				});
			},
			//协会专栏
			getXiehuizhuanlan: function() {
				this.$http.get(this.path + 'index/getNewsList?groupId=10').then((response) => {
					if(response.status === 200) {
						var data = response.body;
						this.xiehuizhuanlan = data.newsList;
					} else {
						this.$message.error("error")
					}

				}, (response) => {

				});
			},
			//党建工作
			getDangjiangongzuo: function() {
				this.$http.get(this.path + 'index/getNewsList?groupId=11').then((response) => {
					if(response.status === 200) {
						var data = response.body;
						this.dangjiangongzuo = data.newsList;
					} else {
						this.$message.error("error")
					}

				}, (response) => {

				});
			},
			//表单提交
			doRegist() {

				//企业名
				if(this.COMPANY == "" || typeof(this.COMPANY) == "undefined") {
					this.$message.error("企业名称不能为空");
					return false;
				}
				var myreg1 = /^[\u4E00-\u9FA5A-Za-z]+$/; //验证规则
				if(!myreg1.test(this.COMPANY)) {
					this.$message.error("请填写正确的企业名称");
					return false;
				}

				//姓名
				if(this.NAME == "" || typeof(this.NAME) == "undefined") {
					this.$message.error("姓名不能为空");
					return false;
				}
				var myreg2 = /^[\u4E00-\u9FA5A-Za-z]+$/; //验证规则
				if(!myreg2.test(this.NAME)) {
					this.$message.error("请填写正确的姓名");
					return false;
				}

				//手机号
				if(this.PHONE == "" || typeof(this.PHONE) == "undefined") {
					this.$message.error("手机号不能为空");
					return false;
				}
				var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/; //验证规则
				if(!myreg.test(this.PHONE)) {
					this.$message.error("请填写正确的手机号");
					return false;
				}

				var content = "企业名称:" + this.COMPANY + ",姓名:" + this.NAME + ",手机号:" + this.PHONE;
				this.$http.post(this.path + 'index/indexFrom?content=' + content).then(function(response) {
					if(response.status === 200) {
						this.$alert('提交成功', ' ', {
							confirmButtonText: '确定',
							callback: action => {
								this.COMPANY = "";
								this.NAME = "";
								this.PHONE = "";
							}
						});
					}
				})
			},

		}
	}
</script>

<style>
	@import "../assets/css/index.css";
	.slideTxtBox .more {
		z-index: 2;
		top: 12px;
	}

	.el-carousel {
		width: 680PX;
	}

	.el-carousel .el-carousel__container {
		height: 400px;
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
	.el-tabs__nav-wrap::after {
		height: 1px;
		background-color: #88a0cb;
	}

	.el-tabs__item:hover {
		color: #18469c;
		cursor: pointer;
	}

	.el-tabs__item.is-active {
		color: #18469c;
	}

	.el-tabs__active-bar {
		height: 1px;
		background-color: #88a0cb;
	}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue